import { Grid } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import DataView from '../../components/DataView';
import ContainerDataView from './ContainerDataView';

const EntregaView = ({ values, isPhone }) => {
  return (
    <>
      <ContainerDataView title="Datos de Entrega">
        <Grid container item xs={12} spacing={isPhone ? 1 : 0}>
          <Grid item xs={12}>
            <DataView
              label="¿A quién entregará las mercaderías?"
              value={values.personaEntrega}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="¿Qué hacer en caso de no efectuarse la entrega?"
              value={values.instruccion}
              isPhone={isPhone}
            />
          </Grid>
        </Grid>
      </ContainerDataView>
    </>
  );
};

export default inject('datos')(observer(withSnackbar(EntregaView)));
